import { Route } from '@angular/router'
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker'
import { AppShellComponent, AuthGuard } from '@vendure/admin-ui/core'
import { AppAuthComponent } from 'src/lib/core/src/components/app-auth/app-auth.component'

export const routes: Route[] = [
  {
    path: 'login',
    component: AppAuthComponent,
    loadChildren: () =>
      import('@vendure/admin-ui/login').then((m) => m.LoginModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    component: AppShellComponent,
    data: {
      breadcrumb: _('breadcrumb.dashboard')
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadChildren: () =>
          import('@vendure/admin-ui/dashboard').then((m) => m.DashboardModule)
      },
      {
        path: 'hotel',
        loadChildren: () =>
          import('src/lib/hotel/src/public_api').then((m) => m.HotelModule)
      },
      {
        path: 'chat',
        loadChildren: () =>
          import('src/lib/chat/src/public_api').then((m) => m.ChatModule)
      },
      {
        path: 'chat-management',
        loadChildren: () =>
          import('src/lib/chat-management/src/public_api').then(
            (m) => m.ChatManagementModule
          )
      },
      {
        path: 'notification',
        loadChildren: () =>
          import('src/lib/notification/src/public_api').then(
            (m) => m.NotificationModule
          )
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('@vendure/admin-ui/settings').then((m) => m.SettingsModule)
      },
      {
        path: 'products',
        loadChildren: () =>
          import('src/lib/product/src/public_api').then((m) => m.ProductModule)
      },
      {
        path: 'merchant-faq',
        loadChildren: () =>
          import('@vendure/admin-ui/merchant-faq').then(
            (m) => m.MerchantFaqModule
          )
      },
      {
        path: 'orders-hotel',
        loadChildren: () =>
          import('@vendure/admin-ui/order-hotel').then(
            (m) => m.OrderHotelModule
          )
      },
      {
        path: 'report-booking-hotel',
        loadChildren: () =>
          import('@vendure/admin-ui/report-booking-hotel').then(
            (m) => m.ReportBookingHotelModule
          )
      },
      {
        path: 'revenue-hotel',
        loadChildren: () =>
          import('@vendure/admin-ui/revenue-hotel').then(
            (m) => m.HotelRevenueModule
          )
      },
      {
        path: 'review-hotel',
        loadChildren: () =>
          import('@vendure/admin-ui/review-hotel').then(
            (m) => m.HotelReviewModule
          )
      },
      {
        path: 'feedback',
        loadChildren: () =>
          import('@vendure/admin-ui/feedback').then(
            (m) => m.FeedbackModule
          )
      }
    ]
  }
]
